import React from "react";
import { Users, FileCheck } from "lucide-react";

export default function Engagements() {
  return (
    <section
      id="impegno"
      data-testid="engagements-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="container-ed">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="overline mb-6">Impegno &amp; Servizi Specialistici</div>
          <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0F172A]">
            Oltre il contenzioso, <span className="italic text-[#A38A5A]">al fianco di chi lavora</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {/* CONFSAL F.I.S.A.L.S. */}
          <article
            data-testid="engagement-confsal"
            className="group bg-white border border-black/10 p-8 md:p-12 transition-shadow duration-300 hover:shadow-xl"
          >
            <div className="flex items-start justify-between gap-4 mb-8">
              <div className="overline text-[10px]">Sindacato</div>
              <div className="h-10 w-10 rounded-full bg-[#FDFBF7] border border-black/10 flex items-center justify-center">
                <Users className="w-4 h-4 text-[#A38A5A]" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="serif text-3xl md:text-4xl leading-tight text-[#0F172A]">
              Referenti per il <span className="italic text-[#A38A5A]">Confsal F.I.S.A.L.S.</span>
            </h3>
            <p className="mt-6 text-base leading-relaxed text-[#1C1917]">
              I due professionisti ricoprono incarichi di responsabilità territoriale per il
              sindacato <span className="text-[#0F172A] font-medium">Confsal F.I.S.A.L.S.</span>,
              assicurando ai lavoratori iscritti un presidio legale diretto e qualificato.
            </p>
            <ul className="mt-8 pt-6 hairline space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <span className="mt-2 h-px w-3 shrink-0 bg-[#A38A5A]" />
                <span className="text-[#1C1917]">
                  <span className="font-medium text-[#0F172A]">Avv. Giovanna Scotti</span> —
                  Responsabile di zona per le province di{" "}
                  <span className="text-[#0F172A]">Chieti</span> e{" "}
                  <span className="text-[#0F172A]">Pescara</span>.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-2 h-px w-3 shrink-0 bg-[#A38A5A]" />
                <span className="text-[#1C1917]">
                  <span className="font-medium text-[#0F172A]">Avv. Salvatore F. A. Bava</span> —
                  Responsabile zonale per la provincia di{" "}
                  <span className="text-[#0F172A]">Cuneo</span>.
                </span>
              </li>
            </ul>
          </article>

          {/* Asseverazione Decreto Flussi */}
          <article
            data-testid="engagement-asseverazione"
            className="group bg-white border border-black/10 p-8 md:p-12 transition-shadow duration-300 hover:shadow-xl"
          >
            <div className="flex items-start justify-between gap-4 mb-8">
              <div className="overline text-[10px]">Servizio Specialistico</div>
              <div className="h-10 w-10 rounded-full bg-[#FDFBF7] border border-black/10 flex items-center justify-center">
                <FileCheck className="w-4 h-4 text-[#A38A5A]" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="serif text-3xl md:text-4xl leading-tight text-[#0F172A]">
              Asseverazione nell'ambito del{" "}
              <span className="italic text-[#A38A5A]">Decreto Flussi</span>
            </h3>
            <p className="mt-6 text-base leading-relaxed text-[#1C1917]">
              Lo Studio offre consulenza qualificata in materia di{" "}
              <span className="text-[#0F172A] font-medium">asseverazione</span> nell'ambito
              del Decreto Flussi, disciplina che trova il proprio riferimento principale
              nell'<span className="text-[#0F172A] font-medium">art. 44 del D.L. 21 giugno 2022, n. 73</span>.
            </p>
            <div className="mt-8 pt-6 hairline">
              <div className="overline text-[10px] mb-4">Destinatari del servizio</div>
              <div className="flex flex-wrap gap-2">
                {["CAF", "Sindacati", "Privati", "Datori di lavoro"].map((t) => (
                  <span
                    key={t}
                    className="inline-flex items-center px-3 py-1.5 text-xs border border-black/15 text-[#1C1917] bg-[#FDFBF7]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
